module.exports = __webpack_public_path__ + "static/grafika2-284fd9d263a717fdfca4a4e98d1f99b8.png";